import React from 'react'
import PropTypes from 'prop-types'
import {customIcon} from '../shared/styles'

const GroupIcon = ({size}) => {
    const {container, content} = customIcon(size, 'indianred')
    return (
        <div style={container}>
            <i data-testid="mi" className="material-icons" style={content}>
                group
            </i>
        </div>
    )
}

GroupIcon.propTypes = {
    size: PropTypes.oneOf(['small', 'medium', 'large', 'x-large']).isRequired
}

export default GroupIcon
